export const SECTION_TITLE_DISTRIBUTOR = 'Distributor';
export const SECTION_TITLE_DEALER = 'Dealers';
export const SECTION_TITLE_EDITORIAL_REVIEWS = 'Editorial Reviews';
export const SECTION_TITLE_CONSUMER_REVIEWS = 'Consumer Reviews';
export const SECTION_TITLE_SIMILAR_NEW_CAR = 'Similar New Cars';
export const SECTION_TITLE_DISCUSSIONS = 'Related Discussions';
export const SECTION_TITLE_RECOMMENDED_FOR_YOU = 'Recommended For You';
export const SECTION_TITLE_RECOMMENDED_TYRES = 'Recommended Tyres';
export const HYBRID_GALLERY_TITLE = 'Unleash the best of every journey.';
// eslint-disable-next-line @stylistic/max-len
export const HYBRID_GALLERY_SUBTITLE = 'Discover the excellence of the Lexus LBX Hybrid.';
export const HYBRID_DES_TITLE = 'More reasons to enjoy the drive.';
// eslint-disable-next-line @stylistic/max-len
export const HYBRID_DES_CONTENT = 'The Lexus LBX redefines the luxury subcompact crossover, blending exceptional performance and captivating style. Perfect for the vibrancy of Singapore’s urban life, the LBX is a statement of taste, refinement, and quiet confidence.';

export const STAR_RATING_ICON_SIZE_DEFAULT = 14;

export const NEW_CARS_COMPARE_LIST_LOCAL_STORAGE_KEY = 'newCarsCompareList';
export const UPCOMING_CAR_PROMPT = 'This is a new model that has yet to be launched. Expected Launch date is'; // @suppress longLineCheck

export const CAR_STATUS_UPCOMING = 'upcoming';
export const CAR_STATUS_AVAILABLE = 'available';
export const CAR_STATUS_PAST = 'past';
export const CAR_STATUS_ON_HOLD = 'hold';
